import config from '../../../config.json';
const env = process.env.REACT_APP_ENVIRONMENT || 'stage';
const BACKEND_URL = config.api[env];
import { backendAPI } from "../../helper/apis";

export function forcePhoneValidation(userId) {
    return backendAPI.post(`${BACKEND_URL}/v3/bo/users/${userId}/forcePhoneValidation`);
}